import mitt, { Emitter, EventType } from "mitt";

import resources from "@/utils/resources";
import { Language } from "../utils/languages";
import process from "@/utils/process";

import { Post, PostData } from "~/types/Post";
import RestResource from "~/modules/rest/RestResource";
import { Model } from "~/types/Model";
import { User } from "~/types/User";
import Cache from "~/modules/cache/Cache";

export class EventBus {
  static instance: EventBus;

  private eventBus: Emitter<Record<EventType, unknown>> | undefined;

  constructor() {
    if (EventBus.instance) return EventBus.instance;

    this.eventBus = mitt();
    EventBus.instance = this;
  }

  $on(event: string, callback: (...args: any) => void) {
    this.eventBus!.on(event, callback);
  }

  $off(event: string, callback: (...args: any) => void) {
    this.eventBus!.off(event, callback);
  }

  $emit(event: string, ...args: any) {
    this.eventBus!.emit(event, args);
  }

  /**
   * Requiere que el usuario ingrese a su cuenta preexistente
   * @param callback
   */
  requireLogin(callback: (...args: any) => any) {
    const router = useRouter();
    router.push("login");
    //this.$emit('requireLogin', callback);
  }
  /**
   * Requiere que el usuario ingrese a su cuenta preexistente o se registre y la confirme,
   * no existe requireRegister, ya que en ningun caso es obligatorio usar una cuenta nueva si ya tenes una
   * @param callback
   */
  requireAuthentication(callback: (...args: any) => any) {
    const router = useRouter();
    router.push("login");
    //this.$emit('requireAuthentication', callback);
  }
  /**
   * Requiere que el usuario verifique su email
   * @param callback
   */
  requireEmailVerification(callback: (...args: any) => any) {
    //this.$emit('requireEmailVerification', callback);
  }
  /**
   * Requiere que el usuario ingrese a su cuenta o se registre, la confirme y compre una membresia
   * @param arg
   * @param
   */
  requireSubscription(arg: any) {
    this.$emit("requireSubscription", arg || {});
  }

  /**
   * Avisarle al usuario que su cuenta fue baneada
   */
  userBanned() {
    this.$emit("userBanned");
  }

  changeLanguage(language: Language) {
    if (!process.client) return;
    const { $i18n, $auth } = useNuxtApp();

    // @ts-ignore
    document.querySelector("html").setAttribute("lang", language.code);

    // @ts-ignore
    $i18n.locale.value = language.code;
    RestResource.setHeader("Accept-Language", language.code);

    // @ts-ignore
    if ($auth.check()) {
      resources.userLastLang.store({ code: language.code })
    }

    try {
      localStorage.setItem("language.selected", language.code);
    } catch (e) {}

    this.$emit("languageChanged", language);

    // this.$cms.forceLanguageUpdate();
  }

  openUnlockPostWithTokens(post: PostData, model: any) {
    this.$emit("openedUnlockPostWithTokens", post, model);
  }

  unlockPostWithTokens(model: Model, post: PostData) {
    this.$emit("unlockedPostWithTokens", model, post);
  }

  updateProfile(data: User) {
    if (data && data.profile_pic) {
      Cache.setUserProfilePicture(data.profile_pic);
    }

    this.$emit('updateProfile', data);
  }

  onUpdateProfile(callback: (data: User) => void) {
    this.$on('updateProfile', callback);
  }
}

export default defineNuxtPlugin(({ app }) => {
  return {
    provide: {
      EventBus: new EventBus(),
    },
  };
});
